<!-- NOTE: my-auto centres the dialog vertically. The user agent's `margin: auto`
     for a modal dialog is overridden by preflight's universal `margin: 0`. -->
<dialog
	#dialog
	[attr.data-test-id]="testId()"
	[class]="
		cn(
			stickyFooter() && 'flex flex-col',
			!showingModal() && 'hidden',
			isMaxWScreenLG()
				? 'max-w-screen-lg lg:mx-auto'
				: 'w-auto max-w-3xl md:mx-auto'
		)
	"
	class="mx-3 my-auto max-h-[calc(100vh-80px)] card p-0 text-dark-primary backdrop:overlay-dark-3 open:animate-fade-in md:max-h-[calc(100vh-120px)] 2xl:max-h-[calc(100vh-160px)]"
>
	<div
		[class]="cn(stickyFooter() ? 'min-h-0' : 'gap-4 md:gap-6')"
		autofocus
		class="flex flex-col p-4 md:p-6"
		tabindex="-1"
	>
		<div
			[class]="
				cn(
					stickyFooter() &&
						'-mx-4 min-h-0 overflow-y-auto px-4 pb-4 md:-mx-6 md:px-6 md:pb-6'
				)
			"
			class="flex flex-col gap-4 md:gap-6"
		>
			@if (title()) {
				<div class="flex items-start">
					<span
						class="w-full text-xl md:text-2xl"
						data-test-id="modal-title"
					>
						{{ title() }}
					</span>
					@if (closeButton()) {
						<svg-icon
							(click)="closeModal()"
							class="size-6 grow-0 cursor-pointer text-black"
							src="assets/icons/icon-cross.svg"
						/>
					}
				</div>
				<hr class="-mx-4 divider md:-mx-6" />
			}
			<div class="children:m-0">
				<ng-content />
			</div>
		</div>
		<div class="flex flex-col-reverse">
			<div #footer class="peer mt-4 empty:hidden md:mt-6">
				<ng-content select="[footer]" />
			</div>
			<hr class="-mx-4 divider peer-empty:hidden md:-mx-6" />
		</div>
	</div>
</dialog>
